import React from 'react'
import {Redirect} from 'react-router-dom'

export const HConnectConfigurationsLanding = () => {
  // A landing page will be added once we expose more HConnect configs
  return <Redirect to="/configuration/hconnect/order-management/" />
}
